import * as Sentry from '@sentry/astro'
const isDev = import.meta.env.DEV

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  environment: isDev ? 'development' : import.meta.env.PUBLIC_ENVIRONMENT
})
